export default __webpack_public_path__ + "static/media/N 프로페셔널 - 그레이.4896ce62.png";